<main id="login" data-testid="login-page" class="h-screen w-screen flex flex-col justify-center">
  <div class=" max-w-sm mx-auto white-card">
    <div class="header-wr">
      <img data-testid="login-image" class="mx-auto company-logo" src="../../../../../assets/logos/aricoma-dark.svg" [attr.alt]="'LOGIN.LOGO_ALT' | translate">
      <h2 data-testid="login-title" class="text-center">{{ 'LOGIN.TITLE' | translate }}</h2>
    </div>
    <div class="form-wr">
      <form data-testid="login-form" #loginForm="ngForm" (ngSubmit)="login(loginForm);">
        <div class="field-wr">
          <label data-testid="login-username-label" for="username" class="block text-sm">{{ 'LOGIN.USERNAME' | translate }}</label>
          <div class="mt-2">
            <input data-testid="login-username-input" name="username" type="text" autocomplete="username" [(ngModel)]="user" required class="text-field">
          </div>
        </div>
        <div class="field-wr">
          <div class="flex items-center justify-between">
            <label data-testid="login-password-label" for="password" class="block text-sm">{{ 'LOGIN.PASSWORD' | translate }}</label>
            <div class="text-sm">
              <a data-testid="login-forgot-password-link" [routerLink]="['/reset-password']" class="forgot-pass">{{ 'LOGIN.FORGOT_PASSWORD' | translate }}</a>
            </div>
          </div>
          <div class="mt-2 password-field-wr">
            <input data-testid="login-password-input" name="password" [type]="showPassword ? 'text' : 'password'"
              autocomplete="current-password" [(ngModel)]="pass" required class="text-field password-field">
            <button data-testid="login-password-toggle" type="button" class="btn-icon-only btn-icon eye-toggle" [ngClass]="showPassword ? 'icon-eye-hide' : 'icon-eye-display'" (click)="togglePasswordVisibility()" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"></button>
          </div>
        </div>
        <div class="btn-wr mt-7">
          <button data-testid="login-submit-btn" type="submit" class="btn primary-btn w-full"> {{ 'LOGIN.LOGIN' | translate }}</button>
        </div>
        @if (displaySSO) {
          <div class="sso-section">
            <div class="divider">
              <div class="line"></div>
              <span data-testid="login-divider-text" class="text">{{ 'LOGIN.OR' | translate }}</span>
              <div class="line"></div>
            </div>
            <button data-testid="login-sso-btn" type="button" class="btn sso-btn w-full" (click)="onSsoLoginClick()">
              {{ 'LOGIN.SSO_LOGIN' | translate }}
            </button>
          </div>
        }
      </form>
    </div>
  </div>
</main>

